// The Stimulus application: Midwest's controllers (every midwest_* component
// that needs JavaScript) plus the app's own, registered by name.
import { Application } from "@hotwired/stimulus";
import { registerMidwestControllers } from "@unabridged/midwest";

import AnnotatorController from "./annotator_controller";
import AttachmentUploadController from "./attachment_upload_controller";
import AutoSubmitController from "./auto_submit_controller";
import CameraController from "./camera_controller";
import CardScanController from "./card_scan_controller";
import CodeEditorController from "./code_editor_controller";
import FunnelController from "./funnel_controller";
import NestedListController from "./nested_list_controller";
import NfcReadController from "./nfc_read_controller";
import NfcWriteController from "./nfc_write_controller";

const application = Application.start();
registerMidwestControllers(application);

application.register("annotator", AnnotatorController);
application.register("attachment-upload", AttachmentUploadController);
application.register("auto-submit", AutoSubmitController);
application.register("camera", CameraController);
application.register("card-scan", CardScanController);
application.register("code-editor", CodeEditorController);
application.register("funnel", FunnelController);
application.register("nested-list", NestedListController);
application.register("nfc-read", NfcReadController);
application.register("nfc-write", NfcWriteController);

export default application;
